import React from 'react';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-width: 100vw;
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

const StyledSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid ${props => props.theme.colors.grey[300]};
  border-radius: 50%;
  border-top-color: ${props => props.theme.colors.secondary.main};
  animation: spin 1s ease-in-out infinite;
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const LoadingText = styled.p`
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: ${props => props.theme.typography.body1.fontSize};
  color: ${props => props.theme.colors.text.secondary};
  margin: 0;
`;

const LoadingSpinner = ({isLoading, message = "로딩 중..." }) => {
  if (!isLoading) return null;
  return (
    <LoadingContainer>
      <SpinnerContainer>
        <StyledSpinner />
        <LoadingText>{message}</LoadingText>
      </SpinnerContainer>
    </LoadingContainer>
  );
};

export default LoadingSpinner; 